import {
    CONTRATOS_CREATE_LOAD,
    CONTRATOS_CREATE_ERROR,
    CONTRATOS_CREATE_SUCCESS,
    CONTRATOS_LOAD,
    CONTRATOS_SUCCESS,
    CONTRATOS_ERROR,
    CONTRATO_LOAD,
    CONTRATO_SUCCESS,
    CONTRATO_ERROR,
    CONTRATOS_PENDENTES_LOAD,
    CONTRATOS_PENDENTES_SUCCESS,
    CONTRATOS_PENDENTES_ERROR,
    CONTRATOS_RESET,
    CONTRATOS_RENEWAL_ERROR,
    CONTRATOS_RENEWAL_LOAD,
    CONTRATOS_RENEWAL_SUCCESS,
    CLEAR_MESSAGE
} from '../actionTypes'

const initialState = {
    message: '',
    success: false,
    isLoading: false,
    contratos: [],
    isLoadingContrato: false,
    contrato: {},
    aportes: {}
}

export default (state = initialState, action) => {
    switch(action.type) {
        case CONTRATOS_RENEWAL_LOAD:
            return {
                ...state,
                isLoading: true
            }
        case CONTRATOS_RENEWAL_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                message: action.payload.message
            }
        case CONTRATOS_RENEWAL_ERROR:
            return {
                ...state,
                isLoading: false,
                message: action.payload.message
            }

        case CONTRATOS_CREATE_LOAD:
            return {
                ...state,
                isLoading: true
            }
        case CONTRATOS_CREATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                message: ''
            }
        case CONTRATOS_CREATE_ERROR:
            return {
                ...state,
                isLoading: false,
                message: action.payload.message
            }
        case CONTRATOS_LOAD:
            return {
                ...state,
                isLoading: true
            }
        case CONTRATOS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                contratos: action.payload.contratos
            }
        case CONTRATOS_ERROR:
            return {
                ...state,
                isLoading: false
            }
        case CONTRATO_LOAD:
            return {
                ...state,
                isLoadingContrato: true
            }
        case CONTRATO_SUCCESS:
            return {
                ...state,
                contrato: action.payload.contrato,
                isLoadingContrato: false,
            }
        case CONTRATO_ERROR:
            return {
                ...state,
                isLoadingContrato: false,
                contrato: {status: false}
            }
        case CONTRATOS_PENDENTES_LOAD:
            return {
                ...state,
                isLoading: true
            }
        case CONTRATOS_PENDENTES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                contratos: action.payload.contratos
            }
        case CONTRATOS_PENDENTES_ERROR:
            return {
                ...state,
                isLoading: false,
                contratos: []
            }
        case CONTRATOS_RESET:
            return {
                ...state,
                success: false
            }
        case CLEAR_MESSAGE:
             return {
                ...state,
                message: null
            }
        default:
            return state
    }
}
